<template>
  <div class="register-view">
    <div class="content">
      <el-form 
        :model="registerForm" 
        status-icon 
        :rules="rules" 
        ref="registerForm" 
        label-width="80px"
        class="form" 
        @keyup.enter.native="submitForm('registerForm')"
      >
        <div class="title">
          <img class="logo" src="../../public/imoa.png" />
          <div>欢迎成为IMOA的用户</div>
        </div>
        
        <el-form-item label="用户名" prop="userName" class="form-item">
          <el-input 
            class="login-input"
            type="text" 
            v-model="registerForm.userName" 
            autocomplete="off" 
            placeholder="用户名(登录使用)"
            maxlength="20"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="昵称" prop="nickName" class="form-item">
          <el-input 
            class="login-input"
            type="text" 
            v-model="registerForm.nickName" 
            autocomplete="off" 
            placeholder="昵称"
            maxlength="20"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="密码" prop="password" class="form-item">
          <el-input 
            class="login-input"
            :type="showPassword ? 'text' : 'password'" 
            v-model="registerForm.password" 
            autocomplete="off" 
            placeholder="密码"
            maxlength="20"
            clearable
          >
            <template #suffix>
              <i 
                :class="showPassword ? 'el-icon-view' : 'el-icon-view-off'" 
                @click="showPassword = !showPassword"
                style="cursor: pointer;"
              ></i>
            </template>
          </el-input>
        </el-form-item>
        
        <el-form-item label="确认密码" prop="confirmPassword" class="form-item">
          <el-input 
            class="login-input"
            :type="showConfirmPassword ? 'text' : 'password'" 
            v-model="registerForm.confirmPassword" 
            autocomplete="off"
            placeholder="确认密码" 
            maxlength="20"
            clearable
          >
            <template #suffix>
              <i 
                :class="showConfirmPassword ? 'el-icon-view' : 'el-icon-view-off'" 
                @click="showConfirmPassword = !showConfirmPassword"
                style="cursor: pointer;"
              ></i>
            </template>
          </el-input>
        </el-form-item>
        
        <el-form-item class="btn-row">
          <div class="btn-row-inner">
            <div class="btn-group">
              <el-button class="login-btn" type="primary" @click="submitForm('registerForm')">
                注册
              </el-button>
              <el-button class="login-btn1" @click="resetForm('registerForm')">
                清空
              </el-button>
            </div>
            <div class="to-login">
              <router-link to="/login">已有账号,前往登录</router-link>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <icp></icp>
  </div>
</template>

<script>
import Icp from '../components/common/Icp.vue';

export default {
  name: "register",
  components: {
    Icp
  },
  data() {
    const validateUserName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名'));
      }
      callback();
    };

    const validateNickName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入昵称'));
      }
      callback();
    };

    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入密码'));
      }
      callback();
    };

    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请再次输入密码'));
      }
      if (value !== this.registerForm.password) {
        return callback(new Error('两次密码输入不一致'));
      }
      callback();
    };

    return {
      showPassword: false,
      showConfirmPassword: false,
      registerForm: {
        userName: '',
        nickName: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        userName: [
          { validator: validateUserName, trigger: 'blur' }
        ],
        nickName: [
          { validator: validateNickName, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/register",
            method: 'post',
            data: this.registerForm
          }).then((data) => {
            this.$message.success("注册成功，正在为您自动登录...");
            // Web 端注册成功后自动登录
            const loginPayload = {
              terminal: this.$enums.TERMINAL_TYPE.WEB,
              userName: this.registerForm.userName,
              password: this.registerForm.password
            };
            this.$http({
              url: '/login',
              method: 'post',
              data: loginPayload
            }).then((loginData) => {
              // 保存 token
              sessionStorage.setItem('accessToken', loginData.accessToken);
              sessionStorage.setItem('refreshToken', loginData.refreshToken);
              // 同步用户名/密码到 cookie，保持与登录页行为一致
              try {
                document.cookie = `username=${encodeURIComponent(loginPayload.userName)}`;
                document.cookie = `password=${encodeURIComponent(loginPayload.password)}`;
              } catch (e) {
                // 忽略 cookie 写入异常
              }
              this.$message.success('登录成功');
              this.$router.push('/home/chat');
            }).catch(() => {
              // 登录失败时仍然跳转到登录页，让用户手动登录
              this.$router.push('/login');
            });
          }).catch(error => {
            this.$message.error(error.response?.data?.message || '注册失败');
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.showPassword = false;
      this.showConfirmPassword = false;
    }
  }
};
</script>

<style scoped lang="scss">
.register-view {
	width: 100%;
	height: 100%;
	background: #e1e6f0;
	background-size: cover;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 40px 16px;

	.content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: stretch;
		max-width: 960px;
		width: 100%;

		/* 背景装饰块，与登录页保持一致 */
		&::before {
			content: "";
			position: absolute;
			inset: 8%;
			border-radius: 32px;
			background: radial-gradient(circle at 0% 0%, rgba(59, 130, 246, 0.09), transparent 55%),
				linear-gradient(135deg, rgba(15, 23, 42, 0.04), rgba(59, 130, 246, 0.02));
			z-index: 0;
		}

		.form {
			position: relative;
			z-index: 1;
			width: 460px;
			min-height: 420px;
			padding: 40px 40px 32px;
			background: #ffffff;
			box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);
			border-radius: 24px;
			border: none;
			overflow: hidden;

			.title {
				display: flex;
				justify-content: center;
				align-items: center;
				line-height: 1;
				margin: 8px 0 28px 0;
				font-size: 22px;
				font-weight: 600;
				letter-spacing: 1px;
				text-align: center;
				color: #111827;

				.logo {
					width: 32px;
					height: 32px;
					margin-right: 10px;
					border-radius: 8px;
				}
			}

			.form-item {
				margin-bottom: 18px;
			}

			.login-input {
				width: 100%;
			}

			>>> .el-input__inner:focus,
			>>> .el-input__inner:hover {
				border-color: #d4def5 !important;
			}

			>>> .el-form-item__label {
				text-align: left;
				color: #6b7280;
			}

			.btn-row {
				margin-top: 18px;
			}
			.btn-row-inner {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 12px;
				height: auto;
				margin-top: 8px;
			}
			.btn-group {
				display: flex;
				gap: 0;
				flex: 0 0 190px;
			}
			.login-btn,
			.login-btn1 {
				flex: 1;
				height: 32px;
				border-radius: 999px;
				font-size: 13px;
			}
			.login-btn {
				background-color: #e1e6f0 !important;
				border-color: #e1e6f0 !important;
				color: #111827 !important;

				&:hover,
				&:focus,
				&:active {
					background-color: #d4def5 !important;
					border-color: #d4def5 !important;
					color: #111827 !important;
					box-shadow: none !important;
				}
			}
			.login-btn1 {
				border-color: #d4def5 !important;
				color: #111827 !important;

				&:hover,
				&:focus,
				&:active {
					background-color: #f7f8fc !important;
					border-color: #d4def5 !important;
					color: #111827 !important;
					box-shadow: none !important;
				}
			}
			.to-login {
				text-align: right;
				font-size: 13px;
				color: #6b7280;
			}
		}
	}
}
</style>
